function ctlEscapeHtml(value = '') {
    return String(value).replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        '\'': '&#39;'
    }[char]));
}

function ctlEscapeAttribute(value = '') {
    return ctlEscapeHtml(value).replace(/`/g, '&#96;');
}

function ctlTrackView(rootElement, channel) {
    if (!rootElement || typeof gtag !== 'function') {
        return;
    }

    const productBlocks = rootElement.querySelectorAll('product-block');
    const productBlocksArray = Array.from(productBlocks);
    const currency = rootElement.dataset.currency || window.Shopify?.currency?.active || '';
    const getVariantValue = (productBlock) => {
        if (!productBlock?.dataset || typeof productBlock.dataset.variant !== 'string') {
            return '';
        }

        return productBlock.dataset.variant.trim();
    };
    const getVariantColor = (productBlock) => {
        const variantValue = getVariantValue(productBlock);
        if (!variantValue) {
            return '';
        }

        return variantValue.split('/')[0].trim();
    };

    let columnCount = 0;

    try {
        productBlocks.forEach((productBlock) => {
            const productImg = productBlock.querySelector('img');
            if (!productImg) {
                return;
            }

            const src = productImg.getAttribute('src');
            const restoredLink = urlRestore(src);
            const observe = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    columnCount += 1;
                    const variantColor = getVariantColor(productBlock);
                    gtag('event', 'view_item_list', {
                        items: [{
                            item_id: productBlock.dataset.productId,
                            item_name: productBlock.dataset.title,
                            price: productBlock.dataset.price,
                            variant: variantColor,
                            item_category5: restoredLink,
                            item_list_name: channel
                        }],
                        currency,
                        item_list_name: channel,
                        item_list_id: 'ctl',
                        transport_type: 'beacon'
                    });
                    observe.unobserve(productImg);
                });
            });

            observe.observe(productImg);

            const productLink = productBlock.querySelector('.product-link');
            if (!productLink || productLink.dataset.ctlTracked === 'true') {
                return;
            }

            productLink.dataset.ctlTracked = 'true';
            productLink.addEventListener('click', (event) => {
                try {
                    event.preventDefault();
                    const link = productLink.getAttribute('href');
                    const variantColor = getVariantColor(productBlock);
                    const variantValue = getVariantValue(productBlock);
                    let navigated = false;
                    const navigate = () => {
                        if (navigated || !link) return;
                        navigated = true;
                        window.location.href = link;
                    };

                    setTimeout(navigate, 250);

                    gtag('event', 'select_item', {
                        transport_type: 'beacon',
                        items: [{
                            item_id: productBlock.dataset.productId,
                            item_name: productBlock.dataset.title,
                            price: productBlock.dataset.price,
                            variant: variantValue || variantColor,
                            image_url: restoredLink
                        }],
                        currency,
                        item_list_name: channel,
                        item_list_id: 'ctl',
                        type: 'anchor',
                        event_callback: navigate
                    });
                } catch (error) {
                    const link = productLink.getAttribute('href');
                    if (link) {
                        window.location.href = link;
                    }
                }
            });
        });
    } catch (error) {
        // no-op
    }

    if (rootElement.trackCTLCarouselHandler) {
        document.removeEventListener('on:carousel-slider:select', rootElement.trackCTLCarouselHandler);
    }

    rootElement.trackCTLCarouselHandler = (event) => {
        if (event.target && !rootElement.contains(event.target)) {
            return;
        }

        const productBlocksData = productBlocksArray.slice(columnCount, event.detail.index + columnCount);
        productBlocksData.forEach((productBlock) => {
            if (!productBlock) {
                return;
            }

            const productImg = productBlock.querySelector('img');
            if (!productImg) {
                return;
            }

            const src = productImg.getAttribute('src');
            const restoredLink = urlRestore(src);
            const variantColor = getVariantColor(productBlock);

            gtag('event', 'view_item_list', {
                items: [{
                    item_id: productBlock.dataset.productId,
                    item_name: productBlock.dataset.title,
                    price: productBlock.dataset.price,
                    variant: variantColor,
                    item_category5: restoredLink,
                    item_list_name: channel
                }],
                currency,
                item_list_name: channel,
                item_list_id: 'ctl',
                transport_type: 'beacon'
            });

            const dataIndex = productBlocksArray.indexOf(productBlock);
            productBlocksArray[dataIndex] = false;
        });
    };

    document.addEventListener('on:carousel-slider:select', rootElement.trackCTLCarouselHandler);
}

if (!window.customElements.get('the-looks')) {
    class TheLooks extends HTMLElement {
        static observedAttributes = ['data-option', 'data-update-count'];

        constructor() {
            super();
            this.option = this.dataset.option || '';
            this.theLookDates = new Map();
            this.currentProductId = this.dataset.productId;
            this.theLookVariants = null;
            this.productUrl = this.dataset.url;
            this.isInitialized = false;
            this.currentTheLookRequestToken = 0;
            this.boundSwitchHandle = this.switchHandle.bind(this);
            this.loadingSwatchLabel = null;
            this.loadingSwatchSpinner = null;
        }

        connectedCallback() {
            this.dataset.channel = this.dataset.title || '';

            const urlParams = new URLSearchParams(window.location.search);
            const color = urlParams.get('Color');
            if (color) {
                this.option = color;
                this.dataset.option = color;
            }

            if (window.initLazyScript) {
                window.initLazyScript(this, () => this.initializeTheLook(), 500);
            } else {
                this.initializeTheLook();
            }
        }

        disconnectedCallback() {
            this.closest('.js-product')?.removeEventListener('on:variant:change', this.boundSwitchHandle);
            if (this.ajaxLoadUrlFetchAbortController) {
                this.ajaxLoadUrlFetchAbortController.abort('TheLooks disconnected');
            }
            this.clearLoadingSwatch();
            if (this.trackCTLCarouselHandler) {
                document.removeEventListener('on:carousel-slider:select', this.trackCTLCarouselHandler);
            }
        }

        initializeTheLook() {
            if (this.isInitialized) return;

            this.theLookVariants = this.getTheLookVariants();
            if (!this.theLookVariants || this.theLookVariants.size === 0) {
                this.classList.add('complete-the-look-hide');
                return;
            }

            this.templateMarkup = this.buildTemplateMarkup();
            if (!this.templateMarkup) {
                this.classList.add('complete-the-look-hide');
                return;
            }

            const currentProductContainer = this.closest('.product-form[data-product-id], .js-product[data-product-id]');
            if (!currentProductContainer) {
                return;
            }

            const currentProductId = currentProductContainer.dataset.productId;
            if (currentProductId && currentProductId !== this.currentProductId) {
                return;
            }

            this.closest('.js-product')?.addEventListener('on:variant:change', this.boundSwitchHandle);
            this.isInitialized = true;
            this.getCurrentTheLookDate(this.dataset.option || this.option || '');
        }

        buildTemplateMarkup() {
            const headingTag = this.dataset.headingTag || 'h4';
            const headingText = this.dataset.heading || '';
            const showDebugLabel = this.dataset.showDebugLabel === 'true';
            const debugLabel = showDebugLabel
                ? '<span style="font-size: 1.2rem; color: #ff6b6b; margin-left: 1rem;">[调试模式]</span>'
                : '';

            return `
<div class="page-width">
  <carousel-slider class="carousel block collection-slider">
    ${headingText ? `
      <div class="opposing-items opposing-items--valign-base very-lightly-spaced-row">
        <${headingTag} class="inline-richtext align-left">
          ${ctlEscapeHtml(headingText)}
          ${debugLabel}
        </${headingTag}>
        <div class="no-wrap slider-nav">
          <button name="prev" class="slider-nav__btn has-ltr-icon" type="button" aria-label="Previous">
            <svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M14.7 6.7L9.4 12l5.3 5.3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
          <button name="next" class="slider-nav__btn has-ltr-icon" type="button" aria-label="Next">
            <svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9.3 17.3L14.6 12 9.3 6.7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </div>
      </div>
    ` : ''}
    <div class="collection-listing fade-in-up slider slider--edge-peek slider--no-scrollbar is-grabbable">
      <div class="slider__grid product-grid product-grid--carousel product-grid--per-row-2 product-grid--per-row-mob-2 complete-the-look__grid" id="Slider-${ctlEscapeAttribute(this.dataset.blockId || '')}" role="list"></div>
    </div>
  </carousel-slider>
</div>`;
        }

        switchHandle(event) {
            const option = event?.detail?.selectedOptions?.[0];
            if (option && option !== this.dataset.option) {
                this.setLoadingSwatchFromEvent(event);
                this.dataset.option = option;
            }
        }

        clearLoadingSwatch() {
            if (this.loadingSwatchSpinner && this.loadingSwatchSpinner.parentNode) {
                this.loadingSwatchSpinner.remove();
            }

            if (this.loadingSwatchLabel) {
                this.loadingSwatchLabel.classList.remove('is-media-loading');
                this.loadingSwatchLabel.removeAttribute('aria-busy');
            }

            this.loadingSwatchLabel = null;
            this.loadingSwatchSpinner = null;
        }

        setLoadingSwatchFromEvent(event) {
            this.clearLoadingSwatch();

            const trigger = event?.detail?.trigger;
            if (!trigger) return;

            const input = trigger.matches('.js-option') ? trigger : trigger.closest('.js-option');
            if (!input?.id) return;

            const variantPicker = input.closest('variant-picker');
            const productRoot = this.closest('.js-product');
            const label = variantPicker?.querySelector(`label[for="${CSS.escape(input.id)}"]`)
                || productRoot?.querySelector(`label[for="${CSS.escape(input.id)}"]`);
            if (!label || !label.classList.contains('opt-label')) return;

            label.classList.add('is-media-loading');
            label.setAttribute('aria-busy', 'true');

            const spinner = document.createElement('span');
            spinner.className = 'opt-label__loading-spinner';
            spinner.setAttribute('aria-hidden', 'true');
            label.appendChild(spinner);

            this.loadingSwatchLabel = label;
            this.loadingSwatchSpinner = spinner;
        }

        getTheLookVariants() {
            if (this.theLookVariants instanceof Map) {
                return this.theLookVariants;
            }

            const blockId = this.dataset.blockId || this.id.replace('complete-the-look-', '');
            const dataElement = document.getElementById(`the-look-data-${blockId}`);
            if (!dataElement) {
                return new Map();
            }

            try {
                return new Map(Object.entries(JSON.parse(dataElement.textContent || '{}')));
            } catch (error) {
                console.error('TheLooks: failed to parse look data.', error);
                return new Map();
            }
        }

        getLookVariantIds(option) {
            const normalizedOption = this.getNormalizedOptionValue(option);
            for (const [key, value] of this.theLookVariants.entries()) {
                if (this.getNormalizedOptionValue(key) === normalizedOption) {
                    return value;
                }
            }

            return null;
        }

        ensureTemplateRendered() {
            if (this.querySelector('.slider__grid')) {
                return;
            }

            if (!this.templateMarkup) {
                return;
            }

            this.insertAdjacentHTML('beforeend', this.templateMarkup);
        }

        renderLoadingState() {
            this.ensureTemplateRendered();
            const completeContainer = this.querySelector('.slider__grid');
            if (!completeContainer) {
                return;
            }

            this.classList.remove('complete-the-look-hide');
            this.classList.add('complete-the-look--loading');
            completeContainer.innerHTML = this.renderSkeletonCards();
        }

        renderSkeletonCards(count = 4) {
            return Array.from({ length: count }, (_, index) => `
<div id="Slide-skeleton-${index}" class="slider__item">
  <div class="ctl-skeleton-card" aria-hidden="true">
    <div class="ctl-skeleton-card__image theme-skeleton theme-skeleton--media"></div>
    <span class="quickadd-icon-btn ctl-skeleton-card__quickadd" aria-hidden="true"></span>
    <div class="ctl-skeleton-card__content">
      <div class="ctl-skeleton-card__title theme-skeleton theme-skeleton--text theme-skeleton--title"></div>
      <div class="ctl-skeleton-card__price theme-skeleton theme-skeleton--text"></div>
    </div>
  </div>
</div>`).join('');
        }

        async getProductsByIds(ids) {
            const query = `
query GetTheLookByVariants($variantIds: [ID!]!) {
  nodes(ids: $variantIds) {
    ... on ProductVariant {
      id
      title
      sku
      image {
        url(transform: { maxWidth: 512, preferredContentType: WEBP })
      }
      price {
        amount
      }
      selectedOptions {
        name
        value
      }
      quantityAvailable
      availableForSale
      hide_preorder_info: metafield(namespace: "custom", key: "hide_preorder_info") {
        value
      }
      pre_order_limit: metafield(namespace: "custom", key: "pre_order_limit") {
        value
      }
      pre_order_shipping_message: metafield(namespace: "custom", key: "pre_order_shipping_message") {
        value
      }
      product {
        id
        title
        handle
        onlineStoreUrl
        images(first: 1) {
          edges {
            node {
              url(transform: { maxWidth: 512, preferredContentType: WEBP })
            }
          }
        }
        variants(first: 100) {
          nodes {
            id
            title
            quantityAvailable
            availableForSale
            image {
              url(transform: { maxWidth: 512, preferredContentType: WEBP })
            }
            price {
              amount
            }
            hide_preorder_info: metafield(namespace: "custom", key: "hide_preorder_info") {
              value
            }
            pre_order_limit: metafield(namespace: "custom", key: "pre_order_limit") {
              value
            }
            pre_order_shipping_message: metafield(namespace: "custom", key: "pre_order_shipping_message") {
              value
            }
            selectedOptions {
              name
              value
            }
          }
        }
        listingChildren: metafield(namespace: "custom", key: "listing_children") {
          references(first: 25) {
            nodes {
              ... on Product {
                id
                title
                handle
                onlineStoreUrl
                images(first: 1) {
                  edges {
                    node {
                      url(transform: { maxWidth: 512, preferredContentType: WEBP })
                    }
                  }
                }
                variants(first: 100) {
                  nodes {
                    id
                    title
                    quantityAvailable
                    availableForSale
                    image {
                      url(transform: { maxWidth: 512, preferredContentType: WEBP })
                    }
                    price {
                      amount
                    }
                    hide_preorder_info: metafield(namespace: "custom", key: "hide_preorder_info") {
                      value
                    }
                    pre_order_limit: metafield(namespace: "custom", key: "pre_order_limit") {
                      value
                    }
                    pre_order_shipping_message: metafield(namespace: "custom", key: "pre_order_shipping_message") {
                      value
                    }
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
            `;

            return this.shopifyFetch(query, { variantIds: ids });
        }

        getNormalizedOptionValue(value) {
            return typeof value === 'string' ? value.replace(/\u200C/g, '').trim().toLowerCase() : '';
        }

        getColorOptionValue(selectedOptions = []) {
            const colorOption = (selectedOptions || []).find((item) => this.getNormalizedOptionValue(item?.name) === 'color');
            return colorOption?.value || '';
        }

        getSameColorVariants(variants = [], colorValue = '') {
            const normalizedColor = this.getNormalizedOptionValue(colorValue);
            if (!normalizedColor) return [];

            return (variants || []).filter((variant) => {
                const variantColor = this.getColorOptionValue(variant?.selectedOptions || []);
                return this.getNormalizedOptionValue(variantColor) === normalizedColor;
            });
        }

        getEntityId(gid = '') {
            return typeof gid === 'string' ? gid.split('/').pop() : '';
        }

        appendWidthParam(url, width) {
            if (!url) return '';
            const separator = url.includes('?') ? '&' : '?';
            return `${url}${separator}width=${width}`;
        }

        formatAmount(amount) {
            const parsed = Number.parseFloat(amount);
            if (Number.isNaN(parsed)) {
                return amount || '';
            }

            return Number.isInteger(parsed) ? String(parsed) : parsed.toFixed(2);
        }

        buildProductUrl(baseUrl, variantId, colorKey, channel) {
            const url = baseUrl || `/products/${this.dataset.handle || ''}`;
            const separator = url.includes('?') ? '&' : '?';
            const params = new URLSearchParams({
                variant: variantId,
                from_section: 'ctl',
                from_title: this.dataset.title || '',
                from_color: colorKey,
                channel
            });
            return `${url}${separator}${params.toString()}`;
        }

        resolveDisplayProduct(productVariant) {
            const parentProduct = productVariant?.product;
            if (!parentProduct) return null;

            const colorValue = this.getColorOptionValue(productVariant.selectedOptions || []);
            const parentVariants = parentProduct?.variants?.nodes || [];
            const listingChildren = parentProduct?.listingChildren?.references?.nodes || [];

            const matchingChildProduct = listingChildren.find((childProduct) => {
                const childVariants = childProduct?.variants?.nodes || [];
                return this.getSameColorVariants(childVariants, colorValue).length > 0;
            });

            const displayProduct = matchingChildProduct || parentProduct;
            let displayVariants = this.getSameColorVariants(displayProduct?.variants?.nodes || [], colorValue);

            if (!displayVariants.length) {
                displayVariants = this.getSameColorVariants(parentVariants, colorValue);
            }

            if (!displayVariants.length && productVariant) {
                displayVariants = [productVariant];
            }

            const anchorVariant = displayVariants[0] || productVariant;
            const cardImage = anchorVariant?.image?.url
                || productVariant?.image?.url
                || displayProduct?.images?.edges?.[0]?.node?.url
                || parentProduct?.images?.edges?.[0]?.node?.url
                || '';
            const amount = anchorVariant?.price?.amount || productVariant?.price?.amount || '';

            return {
                amount,
                anchorVariant,
                cardImage,
                colorValue,
                displayProduct,
                displayVariants
            };
        }

        async getCurrentTheLookDate(option) {
            if (!this.isInitialized) {
                return;
            }

            const key = (option || '').trim();
            const normalizedKey = this.getNormalizedOptionValue(key);
            if (!normalizedKey) {
                this.clearLoadingSwatch();
                this.classList.add('complete-the-look-hide');
                return;
            }

            const requestToken = ++this.currentTheLookRequestToken;
            const currentTheLook = this.getLookVariantIds(key);
            const currentChannel = this.dataset.title || '';
            this.dataset.channel = currentChannel;

            if (!currentTheLook || !Array.isArray(currentTheLook) || !currentTheLook.length) {
                this.clearLoadingSwatch();
                this.classList.add('complete-the-look-hide');
                return;
            }

            this.renderLoadingState();

            const variantIdsUrl = currentTheLook.map((variantId) => `gid://shopify/ProductVariant/${variantId}`);
            let products = null;

            if (this.theLookDates.get(normalizedKey)) {
                products = this.theLookDates.get(normalizedKey);
            } else {
                products = await this.getProductsByIds(variantIdsUrl);
                if (products) {
                    this.theLookDates.set(normalizedKey, products);
                }
            }

            if (requestToken !== this.currentTheLookRequestToken || this.getNormalizedOptionValue(this.dataset.option) !== normalizedKey) {
                return;
            }

            this.clearLoadingSwatch();

            if (!products?.nodes) {
                return;
            }

            this.ensureTemplateRendered();
            const completeContainer = this.querySelector('.slider__grid');
            if (!completeContainer) {
                return;
            }

            const renderedProductKeys = new Set();
            const productCards = products.nodes
                .map((productVariant, index) => {
                    if (!productVariant) return '';

                    const resolvedProduct = this.resolveDisplayProduct(productVariant);
                    if (!resolvedProduct) return '';

                    const {
                        amount,
                        anchorVariant,
                        cardImage,
                        colorValue,
                        displayProduct,
                        displayVariants
                    } = resolvedProduct;

                    const productId = this.getEntityId(displayProduct.id);
                    if (productId === this.currentProductId) return '';

                    const variant = anchorVariant?.title || productVariant.title || '';
                    const currentProductVariantId = this.getEntityId(anchorVariant?.id || productVariant.id);
                    const renderedProductKey = `${productId}::${this.getNormalizedOptionValue(colorValue)}`;
                    if (renderedProductKeys.has(renderedProductKey)) {
                        return '';
                    }

                    renderedProductKeys.add(renderedProductKey);

                    const sizesVariantList = displayVariants.map((currentColorVariant) => {
                        const title = currentColorVariant?.title || '';
                        const titleParts = title.split('/');
                        const size = (titleParts[1] || titleParts[titleParts.length - 1] || '').trim();
                        const id = this.getEntityId(currentColorVariant?.id);
                        const available = Number(currentColorVariant?.quantityAvailable) || 0;
                        const availableForSale = currentColorVariant?.availableForSale === true;
                        const preOrderMessage = currentColorVariant?.pre_order_shipping_message?.value
                            || this.dataset.defaultPreorderMessage
                            || '';
                        const isPreOrder = available < 1 && availableForSale;
                        const isSoldOut = !available && !availableForSale;
                        const cssClass = isPreOrder ? 'pre-order' : (available ? '' : 'sold-out');
                        const statusText = isPreOrder ? '| Pre-Order' : (available ? '' : '| Sold Out');

                        return `<li data-preorder-message="${ctlEscapeAttribute(preOrderMessage)}" data-available="${isPreOrder ? 1 : available}" data-size="${ctlEscapeAttribute(size)}" data-title="${ctlEscapeAttribute(displayProduct.title || '')}" data-variants="${ctlEscapeAttribute(title)}" data-id="${ctlEscapeAttribute(id)}" class="${cssClass}${isSoldOut ? ' sold-out' : ''}">${ctlEscapeHtml(size)} ${statusText}</li>`;
                    }).join('');

                    return this.productBlockBuildHtml({
                        index,
                        id: productId,
                        href: this.buildProductUrl(displayProduct.onlineStoreUrl || `/products/${displayProduct.handle}`, currentProductVariantId, key, currentChannel),
                        imgSrc: cardImage,
                        amount,
                        title: displayProduct.title || '',
                        variant,
                        sizesVariantUl: `<ul>${sizesVariantList}</ul>`
                    });
                })
                .filter(Boolean);

            if (productCards.length > 0
                && this.getNormalizedOptionValue(this.dataset.option) === normalizedKey
                && requestToken === this.currentTheLookRequestToken) {
                this.classList.remove('complete-the-look-hide');
                this.classList.remove('complete-the-look--loading');
                completeContainer.innerHTML = productCards.join('');
                ctlTrackView(this, currentChannel);
                requestAnimationFrame(() => {
                    this.dataset.updateCount = '1';
                });
            } else {
                this.classList.remove('complete-the-look--loading');
                this.classList.add('complete-the-look-hide');
            }
        }

        productBlockBuildHtml({
            id,
            href,
            imgSrc,
            amount,
            title,
            index,
            variant,
            sizesVariantUl
        }) {
            const image1080 = this.appendWidthParam(imgSrc, 1080);
            const image425 = this.appendWidthParam(imgSrc, 425);
            const image1350 = this.appendWidthParam(imgSrc, 1350);
            const displayAmount = this.formatAmount(amount);
            const safeTitle = ctlEscapeHtml(title);
            const safeHref = ctlEscapeAttribute(href);
            const safeVariant = ctlEscapeAttribute(variant);
            const safeAmount = ctlEscapeAttribute(amount);
            const safeProductId = ctlEscapeAttribute(id);
            const safeIcon = ctlEscapeAttribute(this.dataset.addCartIcon || '');
            const isSimpleModal = this.dataset.simpleModal === 'true' ? 'true' : 'false';

            return `
<div id="Slide-${ctlEscapeAttribute(this.currentProductId)}-${index}" class="slider__item">
  <product-block class="product-block" data-variant="${safeVariant}" data-price="${safeAmount}" data-title="${ctlEscapeAttribute(title)}" data-product-id="${safeProductId}" data-product-handle="handle">
    <div class="block-inner">
      <div class="block-inner-inner">
        <div class="image-cont">
          <a class="product-link" href="${safeHref}" aria-hidden="true" tabindex="-1">
            <div class="image-label-wrap">
              <div>
                <div class="product-block__image product-block__image--primary product-block__image--active product-media product-media--image" data-media-id="${safeProductId}">
                  <div class="img-ar img-ar--cover" style="--aspect-ratio: 0.75">
                    <img src="${ctlEscapeAttribute(image1080)}" alt="" width="1080" height="1296" loading="lazy" sizes="100vw" srcset="${ctlEscapeAttribute(image425)} 540w, ${ctlEscapeAttribute(image1350)} 1080w" class="theme-img">
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a class="quickadd-icon-btn quickadd-toggle" data-simple-modal="${isSimpleModal}" href="${safeHref}">
            <span class="visually-hidden">Quick buy</span>
            <img src="${safeIcon}">
          </a>
        </div>
        <div class="product-block__detail align-ltr-left">
          <div class="inner">
            <div class="innerer">
              <a class="product-link" href="${safeHref}">
                <div class="product-block__title">${safeTitle}</div>
                <div class="product-price product-price--block">
                  <div class="price">
                    <div class="price__default">
                      <span class="price__current">$${ctlEscapeHtml(displayAmount)}</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="alert-product">
      <div class="quickadd-container use-color-scheme use-color-scheme--default">
        <div class="inner"></div>
      </div>
    </div>
    <div class="hide size-varint-template">
      ${sizesVariantUl}
    </div>
  </product-block>
</div>`;
        }

        attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'data-option' && oldValue !== newValue) {
                Promise.resolve().then(() => {
                    const key = (newValue || '').replace(/\u200C/g, '');
                    this.getCurrentTheLookDate(key);
                });
            }

            if (name === 'data-update-count') {
                const slider = this.querySelector('carousel-slider');
                if (slider && typeof slider.init === 'function') {
                    slider.init();
                }
            }
        }

        async shopifyFetch(query, variables = {}) {
            const storeDomain = '3d54b1-24.myshopify.com';
            const storefrontAccessToken = 'e568a4e85eae05f90490fc8e90b40098';
            const fetchImpl = window.__themeNativeFetch || (window.fetch ? window.fetch.bind(window) : null);
            if (!fetchImpl) {
                console.error('TheLooks.shopifyFetch: fetch API is unavailable.');
                return null;
            }

            if (this.ajaxLoadUrlFetchAbortController) {
                this.ajaxLoadUrlFetchAbortController.abort('Existing request not needed');
            }
            this.ajaxLoadUrlFetchAbortController = new AbortController();

            let response;
            try {
                response = await fetchImpl(`https://${storeDomain}/api/2025-01/graphql.json`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': storefrontAccessToken
                    },
                    body: JSON.stringify({ query, variables }),
                    signal: this.ajaxLoadUrlFetchAbortController.signal
                });
            } catch (error) {
                if (error?.name === 'AbortError') {
                    return null;
                }
                console.error('TheLooks.shopifyFetch request failed:', error);
                return null;
            }

            let result;
            try {
                if (response && typeof response.json === 'function') {
                    result = await response.json();
                } else if (response && typeof response === 'object') {
                    result = response;
                } else {
                    console.error('TheLooks.shopifyFetch received an unexpected response:', response);
                    return null;
                }
            } catch (error) {
                console.error('TheLooks.shopifyFetch could not parse the response:', error, response);
                return null;
            }

            if (result.errors) {
                console.error('GraphQL Errors:', result.errors);
                return null;
            }

            return result.data;
        }
    }

    window.customElements.define('the-looks', TheLooks);
}
